// Module
var code = "<react-component name=\"ContactForms\"></react-component>\n";
// Exports
module.exports = code;